import axios from 'axios'

/**
 * @desc Fetches all promotions for specified supplier
 * @desc fetchPromotionRulesForSupplier in BFF
 * @param {String} supplierId
 * @param {Object} options
 */
export const fetchSpecials = (supplierId, options = {}) =>
  axios
    .get(`/authenticated/supplier/${supplierId}/promotion-rules`, {
      params: options
    })
    .then((res) => res.data)

/**
 * @desc Creates new promotion for product
 * @desc addPromotionRule in BFF
 * @param {String} supplierId
 * @param {Object} promotion
 */
export const createSpecial = (supplierId, promotion) =>
  axios
    .post(`/authenticated/supplier/${supplierId}/promotion-rules`, promotion)
    .then((res) => res.data)

/**
 * @desc Creates multiple promotions for product/family group
 * @desc addPromotionRules in BFF
 * @param {String} supplierId
 * @param {Object} promotions
 */
export const createMultiSpecials = (supplierId, promotions) =>
  axios
    .post(
      `/authenticated/supplier/${supplierId}/promotion-rules/bulk`,
      promotions
    )
    .then((res) => res.data)

/**
 * @desc Updates promotion
 * @desc editPromotionRule in BFF
 * @param {String} supplierId
 * @param {String} promotionId
 * @param {Object} promotion
 */
export const updateSpecial = (supplierId, promotionId, promotion) =>
  axios
    .put(
      `/authenticated/supplier/${supplierId}/promotion-rules/${promotionId}`,
      promotion
    )
    .then((res) => res.data)

/**
 * @desc Deletes promotion
 * @desc deletePromotionRule in BFF
 * @param {String} supplierId
 * @param {String} promotionId
 */
export const deleteSpecial = (supplierId, promotionId) =>
  axios
    .delete(
      `/authenticated/supplier/${supplierId}/promotion-rules/${promotionId}`
    )
    .then((res) => res.data)

/**
 * @desc Bulk Upload Promotions
 *
 * @param promotions
 */
export const bulkUploadPromotions = (supplierId, promotions) =>
  axios.post(
    `/authenticated/promotion/bulk-upload?supplierId=${supplierId}`,
    promotions
  )

/**
 * @desc getProductsBulkImportExcel (Specials Bulk uploads)
 */
export const fetchBulkSpecialsExcel = () =>
  axios.get('/authenticated/promotion/import/excel').then((res) => res.data)
